// A directed acyclic graph (DAG) implementation
// A child node can have multiple parents

class Node {
  constructor(value, x = null, y = null) {
    this.value = value;
    this.children = [];
    this.parents = [];
    this.x = x;
    this.y = y;
  }
}

class GraphInstance {
  constructor() {
    this.nodes = [];
    this.edges = [];
  }

  addNode(values) {
    console.log("these are the values");
    console.log(values);
    values.forEach((value) => {
      console.log("am the prick", value);
      if (value.value) {
        this.nodes.push(new Node(value.value, value?.x, value?.y));
      }
    });
  }

  addEdge(links) {
    //debugger;
    console.log("these are the links and nodes", links, this.nodes);
    //debugger;
    let p = "";
    let c = "";
    links.forEach(({ source, target }) => {
      console.log(`source and target:${source} and ${target}`);
      console.log(this.nodes);
      //debugger;

      for (let i = 0; i < this.nodes.length; ++i) {
        console.log("--------------------");
        console.log(this.nodes[i], source);
        console.log("--------------------");

        if (this.nodes[i]?.value == source) {
          p = i;
        }
        if (this.nodes[i]?.value == target) {
          c = i;
        }
      }

      console.log(p, "and", c);
      this.nodes[p].children.push(this.nodes[c]);
      this.nodes[c].parents.push(this.nodes[p]);
      this.edges.push({ source: source, target: target });
      c = "";
      p = "";
    });
  }

  removeNode = (node) => {
    let p = "";
    for (let i = 0; i < this.nodes.length; ++i) {
      console.log("--------------------");
      console.log(this.nodes[i]);
      console.log("--------------------");

      if (this.nodes[i]?.value == node) {
        p = i;
        break;
      }
    }

    if (p) {
      this.nodes[p].parents.forEach((parent) => {
        parent.children = parent.children.filter(
          (child) => child.value !== this.nodes[p].value
        );
      });
      this.nodes[p].children.forEach((child) => {
        child.parents = child.parents.filter(
          (parent) => parent.value !== this.nodes[p].value
        );
      });
      this.edges = this.edges.reduce((total, current) => {
        if (
          current.source === this.nodes[p].value ||
          current.target === this.nodes[p].value
        ) {
          return total;
        }
        return [...total, current];
      }, []);
      let tobeRemoved = this.nodes[p].value;
      this.nodes = this.nodes.filter((n) => n.value !== tobeRemoved);
    }
  };

  constructTree = () => {
    let result = {
      nodes: [
        ...this.nodes.map((node) => {
          return {
            id: node.value,
            x: node.x || 0,
            y: node.y || 0,
          };
        }),
      ],
      links: [...this.edges],
    };

    debugger;
    console.log(result);
    return result;
  };

  getEdges = (node) => {
    if (node.children.length) {
      node.children.forEach((child) => {
        this.getEdges(child);
      });
    }
  };

  topologicalSort() {
    // find the root node
    let root = null;
    for (let node of this.nodes) {
      if (node.parents.length === 0) {
        root = node;
        break;
      }
    }
    // perform a dfs on the graph
    let visited = new Set();
    let stack = [];
    const dfs = (node) => {
      if (visited.has(node)) {
        return;
      }
      visited.add(node);
      for (let child of node.children) {
        dfs(child);
      }
      stack.push(node);
    };
    dfs(root);
    return stack;
  }
}

// sample insertion
//let graph = new GraphInstance();
//graph.addNode([0, 1, 2, 3]);

//graph.addEdge([
//  { source: 0, target: 1 },
//  { source: 0, target: 2 },
//  { source: 1, target: 3 },
//  { source: 2, target: 3 },
//]);

//// sample topological sort
//let stack = graph.topologicalSort();
//while (stack.length) {
//  console.log(stack.pop().value);
//}

// sample output
// 0 2 1 3

export default GraphInstance;
